<template>
  <div class="container">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-form-item label="名称">
        <a-input placeholder="请输入名称" v-decorator="['name']" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" style="margin-right: 8px">
          查询
        </a-button>
        <a-button @click="resetForm">
          重置
        </a-button>
      </a-form-item>
    </a-form>
    <!-- <a-button
      type="primary"
      icon="plus"
      @click="handleAdd"
      style="margin: 20px 0;"
      >新建污染源</a-button
    > -->
    <div style="margin-top: 20px">
      <a-table
        :columns="columns"
        :data-source="pollutantList"
        rowKey="id"
        :pagination="{
          current: page,
          total: total,
          pageSize: size,
          onChange: onPageChange
        }"
      >
        <template slot="idx" slot-scope="text, record, index">
          {{ (page - 1) * size + index + 1 }}
        </template>
        <template slot="name" slot-scope="text, record">
          <a @click="openDetail(record)">{{ text }}</a>
        </template>
        <template slot="is_reform" slot-scope="text">
          {{ text ? "是" : "否" }}
        </template>
        <template slot="is_check" slot-scope="text">
          {{ text ? "是" : "否" }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            placement="left"
            @confirm="handleDelete(record)"
            @cancel="$message.warning('取消删除')"
            title="确定删除吗？"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <pollution-detail :show.sync="show" :record="record" v-if="show" />
    <add-or-edit-pollutant
      :action="action"
      :visible.sync="visible"
      :record="record"
      @onOk="
        v => {
          visible = v;
          getPollutantList();
        }
      "
      @onClose="
        v => {
          visible = v;
        }
      "
    ></add-or-edit-pollutant>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PollutionDetail from "./components/PollutionDetail";
import AddOrEditPollutant from "@/components/pollutant_layer/AddOrEditPollutant";
import { getPollutantList, deletePollutant } from "@/api/api";
import { pollutant_columns } from "@/options/columns";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      columns: pollutant_columns,
      pollutantList: [],
      page: 1,
      size: 10,
      total: 0,
      visible: false,
      show: false,
      action: "",
      record: {}
    };
  },
  components: {
    PollutionDetail,
    AddOrEditPollutant
  },
  computed: {
    ...mapState(["authUserInfo"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {
    this.getPollutantList();
  },
  methods: {
    async getPollutantList() {
      try {
        const fieldsValue = this.form.getFieldsValue();
        let name = fieldsValue.name ?? "";
        let res = await getPollutantList({
          group_id: this.defaultInfo.defaultGroupId,
          search: name,
          page: this.page,
          size: this.size
        });
        this.pollutantList = res.data.items;
        this.total = res.data.total;
      } catch (error) {
        console.log(error);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          this.getPollutantList();
        }
      });
    },
    onPageChange(v) {
      this.page = v;
      this.getPollutantList();
    },
    resetForm() {
      this.form.resetFields();
    },
    openDetail(record) {
      this.record = record;
      this.show = true;
    },
    handleAdd() {
      this.action = "add";
      this.visible = true;
    },
    handleEdit(record) {
      this.action = "edit";
      this.record = record;
      this.visible = true;
    },
    async handleDelete(record) {
      try {
        await deletePollutant(record.id);
        this.$message.success("删除成功");
        await this.getPollutantList();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.container {
  padding: 10px;
}
</style>
